class RegistreFiltre  {
    constructor(
        public data_inici= null,
        public data_fi = null,
        public mes = 0,
        public any =0,
    ){
        this.data_inici = data_inici;
        this.data_fi= data_fi;
        this.mes = mes;
        this.any = any;

    }
}
export default RegistreFiltre
